/* eslint-disable react/jsx-props-no-spreading */
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { jobListSelector, totalJobCountSelector } from 'redux/features/jobList';
import { JobCard as Card } from 'components/JobCard';
import type { JobCardProps as CardProps } from 'components/JobCard';
import { measureApplyJob, measureBookmarkJobCard } from '../logics/analytics';
import { NoResult } from './NoResult';
import styles from '../screens/MatchJobListScreen/index.module.scss';

const VALID_TP = ['0', '2'];

/**
 * 求人リストコンポーネント
 *
 * @returns {JSX.Element} 求人リストのJSX要素
 */
export const JobList = () => {
  const jobList = useAppSelector(jobListSelector);
  const totalCount = useAppSelector(totalJobCountSelector);
  const { pic = '1', tp = '1' } = useAppSelector(appQueryParamsSelector);
  const isNoPic = pic === '0';
  const tpValue = VALID_TP.includes(tp) ? tp : '1';

  if (totalCount === 0) return <NoResult />;

  return (
    <section className={styles['matchJobList-jobList']}>
      {jobList.map((job, index) => (
        <JobCard
          job={job}
          isNoPic={isNoPic}
          tp={tpValue}
          imagePriority={index === 0}
          key={job.jid}
        />
      ))}
    </section>
  );
};

/**
 * JobCardコンポーネントのプロパティ
 */
interface JobCardProps extends Omit<CardProps, 'destinationURL'> {
  /** TP値 */
  tp: string;
}

const JobCard = (props: JobCardProps) => {
  const dispatch = useAppDispatch();
  const { tp, job, ...otherProps } = props;
  const destinationURL = `/DodaFront/View/JobSearchDetail/j_jid__${
    job.jid || ''
  }/-fm__list/-tp__${tp}/-mtmd__0/?from=list_${
    job.isRead ? 'browsed' : 'item'
  }`;

  return (
    <Card
      job={job}
      {...otherProps}
      destinationURL={destinationURL}
      onBookmark={() => dispatch(measureBookmarkJobCard(job.jid || ''))}
      onApplyAgent={() => dispatch(measureApplyJob('Agent'))}
      onApplyDirect={() => dispatch(measureApplyJob('Direct'))}
    />
  );
};
